/* This file was automatically generated by tools management permissions. It should not be changed manually. */
import {REG} from "/@lib@/commons/registry.js";
import "/@lib@/wsp/wsp_Perms.js";

const r = REG.reg;
r.newPerm("action.packsMgr#download.wspPack", "dowload.wspPack", 0);
r.newPerm("ui.skinPacksMgr", "show.skinPack", 0);
r.newPerm("action.skinPacksMgr#list", "show.skinPack", 0);
r.newPerm("ui.wspPacksMgr", "use.packs", 0);
r.newPerm("action.wspPacksMgr#list", "list.wspPacks", 0);
r.newPerm("action.wspProps#admin.wsp", "admin.wsp", 0);
r.newPerm("action.packsMgr#download.skinPack", "download.skinPack", 0);
r.newPerm("action.packsMgr#uninstall.skinPack", "delete.skinPack", 0);
r.newPerm("action.packsMgr#uninstall.wspPack", "uninstall.wspPack", 0);
r.newPerm("ui.searchItems.export.items", "read.node.export", 0);
r.newPerm("ui.searchItems.export.props", "read.node.search", 0);
r.newPerm("action.wspProps#update.props", "update.wsp", 0);
r.newPerm("action.wspProps#update.wsptype", "update.wsp", 0);
